import React, { useState } from "react";
import { withLocalize } from "react-localize-redux";
import { Input, Icon, notification } from "antd";
import styled from "styled-components";
import { ModalContent, ModalButton } from "./ConfirmModalStyles";
import { UpdateContactConfirmation } from "../../infra/requests/ContactConfirmationRequests";
import Alerts from "../alert/Alert";

const FormSection = styled.div`
  margin-bottom: 20px;
`;

const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: ${p => p.theme.primaryCTA};
`;

const FieldGroup = styled.div`
  margin-bottom: 12px;

  label {
    display: block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    color: #666;
  }
`;

const ErrorText = styled.span`
  color: #f5222d;
  font-size: 12px;
`;

const ContactConfirmationModal = ({ translate, contactConfirmation, onConfirmed }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    bride: {
      personalEmail: contactConfirmation?.bride?.personalEmail || "",
      personalPhone: contactConfirmation?.bride?.personalPhone || ""
    },
    groom: {
      personalEmail: contactConfirmation?.groom?.personalEmail || "",
      personalPhone: contactConfirmation?.groom?.personalPhone || ""
    }
  });
  const [errors, setErrors] = useState({});

  const handleChange = (person, field, value) => {
    setForm(prev => ({
      ...prev,
      [person]: {
        ...prev[person],
        [field]: value
      }
    }));
    setErrors(prev => ({ ...prev, [`${person}.${field}`]: undefined }));
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!form.bride.personalEmail) newErrors["bride.personalEmail"] = translate("INPUT_ERROR_REQUIRED");
    else if (!emailRegex.test(form.bride.personalEmail)) newErrors["bride.personalEmail"] = translate("INPUT_ERROR_INVALID_EMAIL");

    if (!form.bride.personalPhone) newErrors["bride.personalPhone"] = translate("INPUT_ERROR_REQUIRED");

    if (!form.groom.personalEmail) newErrors["groom.personalEmail"] = translate("INPUT_ERROR_REQUIRED");
    else if (!emailRegex.test(form.groom.personalEmail)) newErrors["groom.personalEmail"] = translate("INPUT_ERROR_INVALID_EMAIL");

    if (!form.groom.personalPhone) newErrors["groom.personalPhone"] = translate("INPUT_ERROR_REQUIRED");

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setLoading(true);
    try {
      const result = await UpdateContactConfirmation(form);
      if (result?.success) {
        Alerts.new({
          type: 'success',
          title: translate('PERSONAL_CONTACTS'),
          text: translate('PERSONAL_CONTACTS_VALIDATED')
        });
        onConfirmed();
      } else {
        Alerts.new({
          type: 'error',
          title: translate('PERSONAL_CONTACTS'),
          text: translate('PERSONAL_CONTACTS_VALIDATED_ERROR')
        });
      }
    } catch (e) {
      Alerts.new({
          type: 'error',
          title: translate('PERSONAL_CONTACTS'),
          text: translate('PERSONAL_CONTACTS_VALIDATED_ERROR')
        });
    }
    setLoading(false);
  };

  return (
    <ModalContent
      title={translate("CONTACT_CONFIRMATION_TITLE")}
      visible={true}
      closable={false}
      maskClosable={false}
      footer={[
        <ModalButton
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          {translate("CONFIRM")}
        </ModalButton>
      ]}
    >
      <p>{translate("CONTACT_CONFIRMATION_DESCRIPTION")}</p>

      <FormSection style={{ marginTop: '15px' }}>
        <SectionTitle>
          {contactConfirmation?.bride?.name || translate("BRIDE")}
        </SectionTitle>
        <FieldGroup>
          <label>{translate("PERSONAL_EMAIL_CONTRACT")}</label>
          <Input
            type="email"
            value={form.bride.personalEmail}
            onChange={e => handleChange("bride", "personalEmail", e.target.value)}
            placeholder={translate("PERSONAL_EMAIL_CONTRACT")}
          />
          {errors["bride.personalEmail"] && <ErrorText>{errors["bride.personalEmail"]}</ErrorText>}
        </FieldGroup>
        <FieldGroup>
          <label>{translate("PERSONAL_PHONE_CONTRACT")}</label>
          <Input
            type="tel"
            value={form.bride.personalPhone}
            onChange={e => handleChange("bride", "personalPhone", e.target.value)}
            placeholder={translate("PERSONAL_PHONE_CONTRACT")}
          />
          {errors["bride.personalPhone"] && <ErrorText>{errors["bride.personalPhone"]}</ErrorText>}
        </FieldGroup>
      </FormSection>

      <FormSection>
        <SectionTitle>
          {contactConfirmation?.groom?.name || translate("GROOM")}
        </SectionTitle>
        <FieldGroup>
          <label>{translate("PERSONAL_EMAIL_CONTRACT")}</label>
          <Input
            type="email"
            value={form.groom.personalEmail}
            onChange={e => handleChange("groom", "personalEmail", e.target.value)}
            placeholder={translate("PERSONAL_EMAIL_CONTRACT")}
          />
          {errors["groom.personalEmail"] && <ErrorText>{errors["groom.personalEmail"]}</ErrorText>}
        </FieldGroup>
        <FieldGroup>
          <label>{translate("PERSONAL_PHONE_CONTRACT")}</label>
          <Input
            type="tel"
            value={form.groom.personalPhone}
            onChange={e => handleChange("groom", "personalPhone", e.target.value)}
            placeholder={translate("PERSONAL_PHONE_CONTRACT")}
          />
          {errors["groom.personalPhone"] && <ErrorText>{errors["groom.personalPhone"]}</ErrorText>}
        </FieldGroup>
      </FormSection>
    </ModalContent>
  );
};

export default withLocalize(ContactConfirmationModal);
